// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___3fxPg","overlayModal":"style__overlayModal___t-DUX","overlayModalInner":"style__overlayModalInner___2Y4Dt","overlayCloseButton":"style__overlayCloseButton___9tQ7_","overlayModalTitle":"style__overlayModalTitle___O_Duk","overlayModalText":"style__overlayModalText___1rYEK","overlayModalTextBold":"style__overlayModalTextBold___p7gxF","overlayModalButtons":"style__overlayModalButtons___kY8JA","overlayModalButtonsItem":"style__overlayModalButtonsItem___2LJYm","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___1RPjg","buttonActive":"style__buttonActive___cfCC7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-market/style.css
// module id = 506
// module chunks = 0